/**
 * View component for /metric-categories
 *
 * Generic metricCategory list view. Defaults to 'all' with:
 * this.props.dispatch(metricCategoryActions.fetchListIfNeeded());
 *
 * NOTE: More list examples are:
 * this.props.dispatch(metricCategoryActions.fetchListIfNeeded("all"));
 * this.props.dispatch(metricCategoryActions.fetchListIfNeeded()).then((data) => {
 *   console.log("DATA", data);
 * });
 * this.props.dispatch(metricCategoryActions.fetchListIfNeeded("_workout"));
 * this.props.dispatch(metricCategoryActions.fetchListIfNeeded("_section", "1234"));
 * this.props.dispatch(metricCategoryActions.fetchList("_section", "3456", "78910")).then(() => {
 *   this.props.dispatch(metricCategoryActions.invalidateList("_section", "3456", "78910"));
 * });
 * this.props.dispatch(metricCategoryActions.setFilter({test: 2}));
 * this.props.dispatch(metricCategoryActions.setFilter({test: 2}, "_section", "1234"));
 * this.props.dispatch(metricCategoryActions.setPagination({test: 1}, "_section", "1234"));
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as metricCategoryActions from '../metricCategoryActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import metricCategory components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import MetricCategoryListItem from '../components/MetricCategoryListItem.js.jsx';

class MetricCategoryList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(metricCategoryActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { location, metricCategoryStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the metricCategoryList meta info here so we can reference 'isFetching'
    const metricCategoryList = metricCategoryStore.lists ? metricCategoryStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual metricCategory objetcs
     */
    const metricCategoryListItems = metricCategoryStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !metricCategoryListItems || !metricCategoryList;

    return (
      <AuthoringLayout>
        <Helmet
          title={"Metric Categories | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Metric Categories
                <Link className="yt-btn create u-pullRight" to={'/admin/authoring/metric-categories/new'}>
                  <img className="-icon" src={'/img/create-white.png'}></img>
                </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (metricCategoryListItems && metricCategoryList && metricCategoryList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: metricCategoryList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {metricCategoryListItems.map((metricCategory, i) =>
                      <MetricCategoryListItem key={metricCategory._id + i} metricCategory={metricCategory} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </AuthoringLayout>
    )
  }
}

MetricCategoryList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    metricCategoryStore: store.metricCategory
  }
}

export default withRouter(
    connect(
    mapStoreToProps
  )(MetricCategoryList)
);



// WEBPACK FOOTER //
// modules/metricCategory/views/MetricCategoryList.js.jsx